
import Header from '../components/Header'
import Hero from '../components/Hero'
import Empresa from '../components/Empresa'
import Valores from '../components/Valores'
import Servicios from '../components/Servicios'
import Galeria from '../components/Galeria'
import Clientes from '../components/Clientes'
import Contacto from '../components/Contacto'
import Footer from '../components/Footer'
import WhatsApp from '../components/Whatsapp'

export function Home() {
    return (
        <div className="">
            <Header />
            <main>
                <Hero />
                <Empresa />
                <Valores />
                <Servicios />
                <Galeria />
                <Clientes />
                <Contacto />
            </main>
            <Footer />
            <WhatsApp />
        </div>
    )
}

export default Home;